import { render, staticRenderFns } from "./RightOption.vue?vue&type=template&id=675442b5&scoped=true"
import script from "./RightOption.vue?vue&type=script&lang=js"
export * from "./RightOption.vue?vue&type=script&lang=js"
import style0 from "./RightOption.vue?vue&type=style&index=0&id=675442b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675442b5",
  null
  
)

export default component.exports